import { UserRole } from '@/constants/user'

export function checkAccessViewZaloDomain(user) {
  const tenantIdEnableZaloPersonalEnv = import.meta.env
    .VITE_TENANT_ENABLE_ZALO_PERSONAL
  const tenantIds = tenantIdEnableZaloPersonalEnv
    ? tenantIdEnableZaloPersonalEnv.split(',')
    : []

  return tenantIds.includes(user.tenant_id) && user.admin
}

export function checkCanAddDeleteZaloAccount(user) {
  const tenantIdEnableZaloPersonalEnv = import.meta.env
    .VITE_TENANT_ENABLE_ZALO_PERSONAL
  const tenantIds = tenantIdEnableZaloPersonalEnv
    ? tenantIdEnableZaloPersonalEnv.split(',')
    : []

  return tenantIds.includes(user.tenant_id) && user.admin
}

export function checkCanUnbindZaloAccount(user) {
  return user.role === UserRole.ADMINISTRATOR
}
